var _g, _rect, _defs;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgSponsoredBrandActive(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 70,
    viewBox: "0 0 100 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7450_46899)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 70,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 84,
    height: 25,
    rx: 5,
    fill: "var(--secondary-4)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9341 15.6758C14.863 15.6909 14.7419 15.7331 14.6651 15.7695C14.4733 15.8604 14.2179 16.1101 14.1252 16.2975C13.9895 16.5715 13.9966 16.3267 14.0026 20.5708L14.0081 24.423L14.0639 24.5725C14.1956 24.9253 14.4738 25.192 14.829 25.3059L14.9807 25.3545H19.2953H23.6098L23.7615 25.3059C24.1168 25.192 24.395 24.9253 24.5267 24.5725L24.5824 24.423L24.5879 20.5708C24.594 16.3267 24.601 16.5715 24.4653 16.2975C24.3728 16.1105 24.1172 15.8604 23.9262 15.7698C23.6487 15.6383 23.9255 15.6456 19.2849 15.647C15.8103 15.6481 15.0406 15.6531 14.9341 15.6758ZM21.2005 17.4458C21.4438 17.5197 21.6696 17.6917 21.8211 17.9186C22.1915 18.4731 21.9745 19.2355 21.3622 19.5309C20.6186 19.8896 19.7631 19.4076 19.6962 18.5923C19.6524 18.0593 20.0544 17.5384 20.6041 17.4158C20.7698 17.3789 21.0222 17.3916 21.2005 17.4458ZM17.8424 19.7335C17.8846 19.7548 17.9468 19.8006 17.9806 19.8354C18.0144 19.8702 18.4986 20.4828 19.0566 21.1967C19.989 22.3896 20.0803 22.4997 20.1822 22.556C20.315 22.6292 20.4817 22.6379 20.6119 22.5783C20.656 22.5581 20.8464 22.394 21.035 22.2136C21.3973 21.8672 21.4378 21.8416 21.6244 21.8414C21.7474 21.8412 21.9004 21.9239 21.9888 22.0383C22.1591 22.2588 23.2573 23.8023 23.3023 23.8844C23.3859 24.0367 23.3533 24.176 23.2196 24.238C23.1544 24.2683 22.8245 24.2711 19.3746 24.2711C15.7414 24.2711 15.5982 24.2697 15.5287 24.2336C15.4328 24.1837 15.3634 24.081 15.364 23.9897C15.3643 23.9496 15.3857 23.8667 15.4117 23.8054C15.5148 23.562 17.4394 19.8632 17.4912 19.8088C17.5993 19.6955 17.7167 19.6703 17.8424 19.7335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.5905,
    y: 15.7559,
    width: 11.1724,
    height: 1.86207,
    rx: 0.931034,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.5905,
    y: 19.6182,
    width: 7.17241,
    height: 1.76509,
    rx: 0.882543,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.5905,
    y: 23.3828,
    width: 4.17241,
    height: 1.86207,
    rx: 0.931034,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 14.7793,
    width: 10,
    height: 8,
    rx: 1.14072,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0768 17.1727C51.0478 17.1782 50.9983 17.1935 50.9669 17.2068C50.8886 17.2398 50.7843 17.3304 50.7465 17.3984C50.691 17.4979 50.6939 17.4091 50.6964 18.9498L50.6986 20.3482L50.7214 20.4025C50.7752 20.5306 50.8888 20.6274 51.0339 20.6687L51.0958 20.6864H52.8579H54.62L54.6819 20.6687C54.827 20.6274 54.9407 20.5306 54.9944 20.4025L55.0172 20.3482L55.0195 18.9498C55.0219 17.4091 55.0248 17.4979 54.9694 17.3984C54.9316 17.3306 54.8272 17.2398 54.7492 17.2069C54.6359 17.1591 54.7489 17.1618 52.8537 17.1623C51.4346 17.1627 51.1203 17.1645 51.0768 17.1727ZM53.636 17.8153C53.7354 17.8421 53.8276 17.9046 53.8895 17.9869C54.0407 18.1883 53.9521 18.465 53.7021 18.5723C53.3984 18.7025 53.049 18.5275 53.0217 18.2315C53.0038 18.038 53.168 17.8489 53.3925 17.8044C53.4601 17.791 53.5632 17.7956 53.636 17.8153ZM52.2646 18.6458C52.2818 18.6535 52.3072 18.6702 52.321 18.6828C52.3348 18.6954 52.5326 18.9178 52.7605 19.177C53.1413 19.61 53.1785 19.65 53.2202 19.6704C53.2744 19.697 53.3425 19.7002 53.3956 19.6785C53.4137 19.6712 53.4914 19.6116 53.5685 19.5461C53.7164 19.4204 53.7329 19.4111 53.8091 19.411C53.8594 19.411 53.9219 19.441 53.958 19.4825C54.0275 19.5626 54.4761 20.1229 54.4944 20.1527C54.5285 20.208 54.5152 20.2585 54.4606 20.2811C54.434 20.2921 54.2993 20.2931 52.8903 20.2931C51.4065 20.2931 51.348 20.2926 51.3197 20.2795C51.2805 20.2614 51.2521 20.2241 51.2524 20.1909C51.2525 20.1764 51.2612 20.1462 51.2718 20.124C51.314 20.0356 52.1 18.6929 52.1211 18.6731C52.1653 18.632 52.2132 18.6229 52.2646 18.6458Z",
    fill: "var(--secondary-4)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 23.7793,
    width: 6,
    height: 0.720869,
    rx: 0.360435,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 25.5,
    width: 4,
    height: 0.720869,
    rx: 0.360435,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 14.7793,
    width: 10,
    height: 8,
    rx: 1.14072,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0768 17.1727C65.0478 17.1782 64.9983 17.1935 64.9669 17.2068C64.8886 17.2398 64.7843 17.3304 64.7465 17.3984C64.691 17.4979 64.6939 17.4091 64.6964 18.9498L64.6986 20.3482L64.7214 20.4025C64.7752 20.5306 64.8888 20.6274 65.0339 20.6687L65.0958 20.6864H66.8579H68.62L68.6819 20.6687C68.827 20.6274 68.9407 20.5306 68.9944 20.4025L69.0172 20.3482L69.0195 18.9498C69.0219 17.4091 69.0248 17.4979 68.9694 17.3984C68.9316 17.3306 68.8272 17.2398 68.7492 17.2069C68.6359 17.1591 68.7489 17.1618 66.8537 17.1623C65.4346 17.1627 65.1203 17.1645 65.0768 17.1727ZM67.636 17.8153C67.7354 17.8421 67.8276 17.9046 67.8895 17.9869C68.0407 18.1883 67.9521 18.465 67.7021 18.5723C67.3984 18.7025 67.049 18.5275 67.0217 18.2315C67.0038 18.038 67.168 17.8489 67.3925 17.8044C67.4601 17.791 67.5632 17.7956 67.636 17.8153ZM66.2646 18.6458C66.2818 18.6535 66.3072 18.6702 66.321 18.6828C66.3348 18.6954 66.5326 18.9178 66.7605 19.177C67.1413 19.61 67.1785 19.65 67.2202 19.6704C67.2744 19.697 67.3425 19.7002 67.3956 19.6785C67.4137 19.6712 67.4914 19.6116 67.5685 19.5461C67.7164 19.4204 67.7329 19.4111 67.8091 19.411C67.8594 19.411 67.9219 19.441 67.958 19.4825C68.0275 19.5626 68.4761 20.1229 68.4944 20.1527C68.5285 20.208 68.5152 20.2585 68.4606 20.2811C68.434 20.2921 68.2993 20.2931 66.8903 20.2931C65.4065 20.2931 65.348 20.2926 65.3197 20.2795C65.2805 20.2614 65.2521 20.2241 65.2524 20.1909C65.2525 20.1764 65.2612 20.1462 65.2718 20.124C65.314 20.0356 66.1 18.6929 66.1211 18.6731C66.1653 18.632 66.2132 18.6229 66.2646 18.6458Z",
    fill: "var(--secondary-4)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 23.7793,
    width: 6,
    height: 0.720869,
    rx: 0.360435,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 25.5,
    width: 4,
    height: 0.720869,
    rx: 0.360435,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 14.7793,
    width: 10,
    height: 8,
    rx: 1.14072,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.0768 17.1727C79.0478 17.1782 78.9983 17.1935 78.9669 17.2068C78.8886 17.2398 78.7843 17.3304 78.7465 17.3984C78.691 17.4979 78.6939 17.4091 78.6964 18.9498L78.6986 20.3482L78.7214 20.4025C78.7752 20.5306 78.8888 20.6274 79.0339 20.6687L79.0958 20.6864H80.8579H82.62L82.6819 20.6687C82.827 20.6274 82.9407 20.5306 82.9944 20.4025L83.0172 20.3482L83.0195 18.9498C83.0219 17.4091 83.0248 17.4979 82.9694 17.3984C82.9316 17.3306 82.8272 17.2398 82.7492 17.2069C82.6359 17.1591 82.7489 17.1618 80.8537 17.1623C79.4346 17.1627 79.1203 17.1645 79.0768 17.1727ZM81.636 17.8153C81.7354 17.8421 81.8276 17.9046 81.8895 17.9869C82.0407 18.1883 81.9521 18.465 81.7021 18.5723C81.3984 18.7025 81.049 18.5275 81.0217 18.2315C81.0038 18.038 81.168 17.8489 81.3925 17.8044C81.4601 17.791 81.5632 17.7956 81.636 17.8153ZM80.2646 18.6458C80.2818 18.6535 80.3072 18.6702 80.321 18.6828C80.3348 18.6954 80.5326 18.9178 80.7605 19.177C81.1413 19.61 81.1785 19.65 81.2202 19.6704C81.2744 19.697 81.3425 19.7002 81.3956 19.6785C81.4137 19.6712 81.4914 19.6116 81.5685 19.5461C81.7164 19.4204 81.7329 19.4111 81.8091 19.411C81.8594 19.411 81.9219 19.441 81.958 19.4825C82.0275 19.5626 82.4761 20.1229 82.4944 20.1527C82.5285 20.208 82.5152 20.2585 82.4606 20.2811C82.434 20.2921 82.2993 20.2931 80.8903 20.2931C79.4065 20.2931 79.348 20.2926 79.3197 20.2795C79.2805 20.2614 79.2521 20.2241 79.2524 20.1909C79.2525 20.1764 79.2612 20.1462 79.2718 20.124C79.314 20.0356 80.1 18.6929 80.1211 18.6731C80.1653 18.632 80.2132 18.6229 80.2646 18.6458Z",
    fill: "var(--secondary-4)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 23.7793,
    width: 6,
    height: 0.720869,
    rx: 0.360435,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 25.5,
    width: 4,
    height: 0.720869,
    rx: 0.360435,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 39,
    width: 20.9032,
    height: 20.9032,
    rx: 3.48387,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6259 45.2191C14.5635 45.2323 14.4573 45.2693 14.3899 45.3012C14.2217 45.381 13.9976 45.6001 13.9163 45.7644C13.7973 46.0049 13.8034 45.7901 13.8087 49.5131L13.8136 52.8924L13.8625 53.0235C13.978 53.333 14.2221 53.5669 14.5337 53.6669L14.6667 53.7095H18.4516H22.2365L22.3695 53.6669C22.6812 53.5669 22.9252 53.333 23.0408 53.0235L23.0897 52.8924L23.0945 49.5131C23.0998 45.7901 23.106 46.0049 22.9869 45.7644C22.9058 45.6004 22.6815 45.381 22.514 45.3016C22.2706 45.1862 22.5134 45.1926 18.4425 45.1938C15.3945 45.1947 14.7193 45.1992 14.6259 45.2191ZM20.123 46.7718C20.3364 46.8366 20.5345 46.9875 20.6673 47.1865C20.9923 47.673 20.8019 48.3418 20.2648 48.6009C19.6125 48.9156 18.862 48.4928 18.8033 47.7775C18.7649 47.3099 19.1176 46.853 19.5998 46.7455C19.7451 46.7131 19.9665 46.7242 20.123 46.7718ZM17.1771 48.7786C17.2141 48.7973 17.2687 48.8375 17.2984 48.868C17.328 48.8986 17.7528 49.4359 18.2423 50.0622C19.0602 51.1086 19.1403 51.2052 19.2297 51.2546C19.3462 51.3189 19.4924 51.3264 19.6066 51.2741C19.6453 51.2564 19.8123 51.1125 19.9778 50.9542C20.2956 50.6503 20.3311 50.6279 20.4948 50.6277C20.6027 50.6276 20.737 50.7001 20.8145 50.8004C20.9639 50.9939 21.9273 52.3479 21.9668 52.4199C22.04 52.5535 22.0115 52.6757 21.8942 52.7301C21.837 52.7567 21.5476 52.7592 18.5212 52.7592C15.3341 52.7592 15.2084 52.7579 15.1475 52.7263C15.0633 52.6825 15.0025 52.5924 15.003 52.5123C15.0032 52.4771 15.022 52.4044 15.0448 52.3506C15.1353 52.1371 16.8236 48.8924 16.8691 48.8447C16.9639 48.7453 17.0669 48.7232 17.1771 48.7786Z",
    fill: "var(--secondary-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 62.2256,
    width: 18.5806,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 66.1738,
    width: 14.2928,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.5484,
    y: 39,
    width: 20.9032,
    height: 20.9032,
    rx: 3.48387,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1743 45.2191C46.1119 45.2323 46.0057 45.2693 45.9383 45.3012C45.7701 45.381 45.546 45.6001 45.4647 45.7644C45.3457 46.0049 45.3518 45.7901 45.3571 49.5131L45.362 52.8924L45.4109 53.0235C45.5264 53.333 45.7705 53.5669 46.0821 53.6669L46.2151 53.7095H50H53.7849L53.9179 53.6669C54.2296 53.5669 54.4736 53.333 54.5892 53.0235L54.6381 52.8924L54.6429 49.5131C54.6482 45.7901 54.6544 46.0049 54.5353 45.7644C54.4542 45.6004 54.2299 45.381 54.0624 45.3016C53.819 45.1862 54.0618 45.1926 49.9909 45.1938C46.9429 45.1947 46.2677 45.1992 46.1743 45.2191ZM51.6714 46.7718C51.8848 46.8366 52.0829 46.9875 52.2157 47.1865C52.5407 47.673 52.3503 48.3418 51.8132 48.6009C51.1609 48.9156 50.4104 48.4928 50.3517 47.7775C50.3133 47.3099 50.666 46.853 51.1482 46.7455C51.2935 46.7131 51.5149 46.7242 51.6714 46.7718ZM48.7255 48.7786C48.7625 48.7973 48.8171 48.8375 48.8468 48.868C48.8764 48.8986 49.3012 49.4359 49.7907 50.0622C50.6086 51.1086 50.6887 51.2052 50.7781 51.2546C50.8946 51.3189 51.0408 51.3264 51.155 51.2741C51.1937 51.2564 51.3607 51.1125 51.5262 50.9542C51.844 50.6503 51.8795 50.6279 52.0432 50.6277C52.1511 50.6276 52.2854 50.7001 52.3629 50.8004C52.5123 50.9939 53.4757 52.3479 53.5152 52.4199C53.5884 52.5535 53.5599 52.6757 53.4426 52.7301C53.3854 52.7567 53.096 52.7592 50.0696 52.7592C46.8825 52.7592 46.7568 52.7579 46.6959 52.7263C46.6117 52.6825 46.5509 52.5924 46.5514 52.5123C46.5516 52.4771 46.5704 52.4044 46.5932 52.3506C46.6837 52.1371 48.372 48.8924 48.4175 48.8447C48.5123 48.7453 48.6153 48.7232 48.7255 48.7786Z",
    fill: "var(--secondary-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.5484,
    y: 62.2256,
    width: 18.5806,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.5484,
    y: 66.1738,
    width: 14.2928,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.0968,
    y: 39,
    width: 20.9032,
    height: 20.9032,
    rx: 3.48387,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7227 45.2191C77.6603 45.2323 77.5541 45.2693 77.4867 45.3012C77.3184 45.381 77.0944 45.6001 77.0131 45.7644C76.894 46.0049 76.9002 45.7901 76.9055 49.5131L76.9103 52.8924L76.9592 53.0235C77.0748 53.333 77.3188 53.5669 77.6305 53.6669L77.7635 53.7095H81.5484H85.3333L85.4663 53.6669C85.778 53.5669 86.022 53.333 86.1375 53.0235L86.1865 52.8924L86.1913 49.5131C86.1966 45.7901 86.2027 46.0049 86.0837 45.7644C86.0025 45.6004 85.7783 45.381 85.6108 45.3016C85.3673 45.1862 85.6102 45.1926 81.5393 45.1938C78.4912 45.1947 77.816 45.1992 77.7227 45.2191ZM83.2198 46.7718C83.4332 46.8366 83.6312 46.9875 83.7641 47.1865C84.089 47.673 83.8987 48.3418 83.3616 48.6009C82.7093 48.9156 81.9588 48.4928 81.9001 47.7775C81.8617 47.3099 82.2143 46.853 82.6966 46.7455C82.8419 46.7131 83.0633 46.7242 83.2198 46.7718ZM80.2739 48.7786C80.3109 48.7973 80.3655 48.8375 80.3951 48.868C80.4248 48.8986 80.8495 49.4359 81.3391 50.0622C82.157 51.1086 82.237 51.2052 82.3265 51.2546C82.443 51.3189 82.5892 51.3264 82.7034 51.2741C82.7421 51.2564 82.9091 51.1125 83.0746 50.9542C83.3924 50.6503 83.4279 50.6279 83.5916 50.6277C83.6995 50.6276 83.8337 50.7001 83.9112 50.8004C84.0607 50.9939 85.0241 52.3479 85.0635 52.4199C85.1368 52.5535 85.1082 52.6757 84.991 52.7301C84.9338 52.7567 84.6444 52.7592 81.618 52.7592C78.4309 52.7592 78.3052 52.7579 78.2443 52.7263C78.1601 52.6825 78.0992 52.5924 78.0998 52.5123C78.1 52.4771 78.1188 52.4044 78.1416 52.3506C78.2321 52.1371 79.9204 48.8924 79.9658 48.8447C80.0607 48.7453 80.1637 48.7232 80.2739 48.7786Z",
    fill: "var(--secondary-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.0968,
    y: 62.2256,
    width: 18.5806,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.0968,
    y: 66.1738,
    width: 14.2928,
    height: 1.62581,
    rx: 0.812903,
    fill: "var(--secondary-1)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 69,
    rx: 5.5,
    stroke: "var(--secondary-1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7450_46899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 70,
    rx: 6,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsoredBrandActive);
export default __webpack_public_path__ + "static/media/sponsored-brand-active.3d1cfb9ada330cae146bfea040d50513.svg";
export { ForwardRef as ReactComponent };